import { Component, OnInit, Input as RouteInput } from '@angular/core';
import { AuthorizeService } from '@platform/auth/authorize.service';
import { Observable, combineLatest, map } from 'rxjs';

@Component({
  selector: 'app-cockpit',
  templateUrl: './cockpit.component.html',
  styleUrls: ['./cockpit.component.scss'],
  standalone: false,
})
export class CockpitComponent implements OnInit {
  @RouteInput() customerSpaceId!: string;

  customerSpaceName: string;

  showEditorOrPayrollWidget$: Observable<boolean>;

  constructor(private auth: AuthorizeService) {}

  ngOnInit(): void {
    const isCreditor$ = this.auth.isAuthorized(
      'APP_INBOX_UPLOAD_READ',
      new Map<string, string>([
        ['customerSpaceId', this.customerSpaceId],
        ['inbox', 'creditor'],
      ]),
    );
    const isPayroll$ = this.auth.isAuthorized(
      'APP_INBOX_UPLOAD_READ',
      new Map<string, string>([
        ['customerSpaceId', this.customerSpaceId],
        ['inbox', 'payroll'],
      ]),
    );
    this.showEditorOrPayrollWidget$ = combineLatest([isCreditor$, isPayroll$]).pipe(
      map(([isCreditor, isPayroll]) => isCreditor || isPayroll),
    );
  }
}
